import UrlsService from "../../helpers/UrlsService";
import APIService from "../../helpers/APIService";

const getDefaultState = function() {
    return {
        // Initial state
        techClasses: {
            "Data & Intelligence": {
                color: "#BC4328",
            },
            "Intelligent Automation": {
                color: "#E6B600",
            },
            "Customer Experience": {
                color: "#0F1C50",
            },
            "Internet of Things": {
                color: "#83B254",
            },
            "Optimized IT": {
                color: "#AA3C80",
            },
            "Cybersecurity": {
                color: "#0080B1",
            },
        },
        bizClasses: {
            "Insurance": {
                color: "#BC4328",
            },
            "Industry": {
                color: "#E6B600",
            },
            "People & Healthcare": {
                color: "#0F1C50",
            },
            "Energy & Utilities": {
                color: "#83B254",
            },
            "Telco & Media": {
                color: "#AA3C80",
            },
            "Banking": {
                color: "#0080B1",
            },
        },
        sources: [
            {
                category: "Data & Intelligence",
                synonyms: ["trenduccio","trendino"],
                r: "ADOPT",
                title: "trend 1",
                description: "Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. ",
                business_impact: "Disruptive",
                business_relevance: "High"
            },
            {
                category: "Data & Intelligence",
                synonyms: ["trendissimo","trenderrimo"],
                r: "TRY",
                title: "trend 2",
                description: "Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. ",
                business_impact: "Evolutional",
                business_relevance: "Medium"
            },
            {
                category: "Intelligent Automation",
                synonyms: ["sinonimo 1","sinonimo 2", "sinonimo 3"],
                r: "ASSESS",
                title: "Trend 3",
                description: "Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. ",
                business_impact: "Disruptive",
                business_relevance: "Low"
            },
            {
                category: "Customer Experience",
                synonyms: ["customer experience","experience customer"],
                r: "ADOPT",
                title: "Trend 4",
                description: "Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. ",
                business_impact: "Evolutional",
                business_relevance: "High"
            },
            {
                category: "Internet of Things",
                synonyms: ["trend five","trendfive"],
                r: "TRY",
                title: "Trend 5",
                description: "Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. ",
                business_impact: "Disruptive",
                business_relevance: "Medium"
            },
            {
                category: "Optimized IT",
                synonyms: ["six","6"],
                r: "ASSESS",
                title: "Trend 6",
                description: "Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. ",
                business_impact: "Evolutional",
                business_relevance: "Low"
            },
            {
                category: "Cybersecurity",
                synonyms: ["iot","aiot"],
                r:"ADOPT",
                title: "Trend 7",
                description: "Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. Una descrizione abbastanza corposa. ",
                business_impact: "Disruptive",
                business_relevance: "High"
            }
        ],
        documents: [
            {
                "document_id": "http://arxiv.org/abs/2108.00914v1",
                "source": "arxiv",
                "title": "Hardness and Approximation of Submodular Minimum Linear Ordering Problems",
                "content_original": "The minimum linear ordering problem (MLOP) seeks to minimize an aggregated\ncost $f(\\cdot)$ due to an ordering $\\sigma$ of the items (say $[n]$), i.e.,\n$\\min_{\\sigma} \\sum_{i\\in [n]} f(E_{i,\\sigma})$, where $E_{i,\\sigma}$ is the\nset of items that are mapped by $\\sigma$ to indices at most $i$. This problem\nhas been studied in the literature for various special cases of the cost\nfunction $f$, and in a general setting for a submodular or supermodular cost\n$f$ [ITT2012]. Though MLOP was known to be NP-hard for general submodular\nfunctions, it was unknown whether the special case of graphic matroid MLOP\n(with $f$ being the matroid rank function of a graph) was polynomial-time\nsolvable. Following this motivation, we explore related classes of linear\nordering problems, including symmetric submodular MLOP, minimum latency vertex\ncover, and minimum sum vertex cover. We show that the most special cases of our\nproblem, graphic matroid MLOP and minimum latency vertex cover, are both\nNP-hard.\n  We further expand the toolkit for approximating MLOP variants: using the\ntheory of principal partitions, we show a $2-\\frac{1+\\ell_{f}}{1+|E|}$\napproximation to monotone submodular MLOP, where\n$\\ell_{f}=\\frac{f(E)}{\\max_{x\\in E}f(\\{x\\})}$ satisfies $1 \\leq \\ell_f \\leq\n|E|$. Thus our result improves upon the best known bound of $2-\\frac{2}{1+|E|}$\nby Iwata, Tetali, and Tripathi [ITT2012]. This leads to a\n$2-\\frac{1+r(E)}{1+|E|}$ approximation for the matroid MLOP, corresponding to\nthe case when $r$ is the rank function of a given matroid. Finally, we show\nthat MLVC can be $4/3$ approximated, matching the integrality gap of its\nvanilla LP relaxation.",
                "content": "The minimum linear ordering problem (MLOP) seeks to minimize an aggregated\ncost $f(\\cdot)$ due to an ordering $\\sigma$ of the items (say $[n]$), i.e.,\n$\\min_{\\sigma} \\sum_{i\\in [n]} f(E_{i,\\sigma})$, where $E_{i,\\sigma}$ is the\nset of items that are mapped by $\\sigma$ to indices at most $i$. This problem\nhas been studied in the literature for various special cases of the cost\nfunction $f$, and in a general setting for a submodular or supermodular cost\n$f$ [ITT2012]. Though MLOP was known to be NP-hard for general submodular\nfunctions, it was unknown whether the special case of graphic matroid MLOP\n(with $f$ being the matroid rank function of a graph) was polynomial-time\nsolvable. Following this motivation, we explore related classes of linear\nordering problems, including symmetric submodular MLOP, minimum latency vertex\ncover, and minimum sum vertex cover. We show that the most special cases of our\nproblem, graphic matroid MLOP and minimum latency vertex cover, are both\nNP-hard.\n  We further expand the toolkit for approximating MLOP variants: using the\ntheory of principal partitions, we show a $2-\\frac{1+\\ell_{f}}{1+|E|}$\napproximation to monotone submodular MLOP, where\n$\\ell_{f}=\\frac{f(E)}{\\max_{x\\in E}f(\\{x\\})}$ satisfies $1 \\leq \\ell_f \\leq\n|E|$. Thus our result improves upon the best known bound of $2-\\frac{2}{1+|E|}$\nby Iwata, Tetali, and Tripathi [ITT2012]. This leads to a\n$2-\\frac{1+r(E)}{1+|E|}$ approximation for the matroid MLOP, corresponding to\nthe case when $r$ is the rank function of a given matroid. Finally, we show\nthat MLVC can be $4/3$ approximated, matching the integrality gap of its\nvanilla LP relaxation.",
                "timestamp": "data",
                "metadata": {
                    "authors": [
                        "Majid Farhadi",
                        "Swati Gupta",
                        "Shengding Sun",
                        "Prasad Tetali",
                        "Michael C. Wigal"
                    ],
                    "categories": [
                        "cs.DS",
                        "cs.CC"
                    ],
                    "updated_timestamp": "data",
                    "search_query": "abs:%22MLOps%22 AND (cat:cs* OR cat:eess* OR cat:math.IT OR cat:quant-ph OR cat:stat.ML)",
                    "search_key": "MLOps"
                },
            },
            {
                "document_id" : "http://arxiv.org/abs/2108.00914v1",
                "source" : "arxiv",
                "title" : "Title 2",
                "content_original" : "The minimum linear ordering problem (MLOP) seeks to minimize an aggregated\ncost $f(\\cdot)$ due to an ordering $\\sigma$ of the items (say $[n]$), i.e.,\n$\\min_{\\sigma} \\sum_{i\\in [n]} f(E_{i,\\sigma})$, where $E_{i,\\sigma}$ is the\nset of items that are mapped by $\\sigma$ to indices at most $i$. This problem\nhas been studied in the literature for various special cases of the cost\nfunction $f$, and in a general setting for a submodular or supermodular cost\n$f$ [ITT2012]. Though MLOP was known to be NP-hard for general submodular\nfunctions, it was unknown whether the special case of graphic matroid MLOP\n(with $f$ being the matroid rank function of a graph) was polynomial-time\nsolvable. Following this motivation, we explore related classes of linear\nordering problems, including symmetric submodular MLOP, minimum latency vertex\ncover, and minimum sum vertex cover. We show that the most special cases of our\nproblem, graphic matroid MLOP and minimum latency vertex cover, are both\nNP-hard.\n  We further expand the toolkit for approximating MLOP variants: using the\ntheory of principal partitions, we show a $2-\\frac{1+\\ell_{f}}{1+|E|}$\napproximation to monotone submodular MLOP, where\n$\\ell_{f}=\\frac{f(E)}{\\max_{x\\in E}f(\\{x\\})}$ satisfies $1 \\leq \\ell_f \\leq\n|E|$. Thus our result improves upon the best known bound of $2-\\frac{2}{1+|E|}$\nby Iwata, Tetali, and Tripathi [ITT2012]. This leads to a\n$2-\\frac{1+r(E)}{1+|E|}$ approximation for the matroid MLOP, corresponding to\nthe case when $r$ is the rank function of a given matroid. Finally, we show\nthat MLVC can be $4/3$ approximated, matching the integrality gap of its\nvanilla LP relaxation.",
                "content" : "The minimum linear ordering problem (MLOP) seeks to minimize an aggregated\ncost $f(\\cdot)$ due to an ordering $\\sigma$ of the items (say $[n]$), i.e.,\n$\\min_{\\sigma} \\sum_{i\\in [n]} f(E_{i,\\sigma})$, where $E_{i,\\sigma}$ is the\nset of items that are mapped by $\\sigma$ to indices at most $i$. This problem\nhas been studied in the literature for various special cases of the cost\nfunction $f$, and in a general setting for a submodular or supermodular cost\n$f$ [ITT2012]. Though MLOP was known to be NP-hard for general submodular\nfunctions, it was unknown whether the special case of graphic matroid MLOP\n(with $f$ being the matroid rank function of a graph) was polynomial-time\nsolvable. Following this motivation, we explore related classes of linear\nordering problems, including symmetric submodular MLOP, minimum latency vertex\ncover, and minimum sum vertex cover. We show that the most special cases of our\nproblem, graphic matroid MLOP and minimum latency vertex cover, are both\nNP-hard.\n  We further expand the toolkit for approximating MLOP variants: using the\ntheory of principal partitions, we show a $2-\\frac{1+\\ell_{f}}{1+|E|}$\napproximation to monotone submodular MLOP, where\n$\\ell_{f}=\\frac{f(E)}{\\max_{x\\in E}f(\\{x\\})}$ satisfies $1 \\leq \\ell_f \\leq\n|E|$. Thus our result improves upon the best known bound of $2-\\frac{2}{1+|E|}$\nby Iwata, Tetali, and Tripathi [ITT2012]. This leads to a\n$2-\\frac{1+r(E)}{1+|E|}$ approximation for the matroid MLOP, corresponding to\nthe case when $r$ is the rank function of a given matroid. Finally, we show\nthat MLVC can be $4/3$ approximated, matching the integrality gap of its\nvanilla LP relaxation.",
                "timestamp" : "data",
                "metadata" : {
                    "authors" : [
                        "Majid Farhadi",
                        "Swati Gupta",
                        "Shengding Sun",
                        "Prasad Tetali",
                        "Michael C. Wigal"
                    ],
                    "categories" : [
                        "cs.DS",
                        "cs.CC"
                    ],
                    "updated_timestamp" : "data",
                    "search_query" : "abs:%22MLOps%22 AND (cat:cs* OR cat:eess* OR cat:math.IT OR cat:quant-ph OR cat:stat.ML)",
                    "search_key" : "MLOps"
                },
            }
        ]
    };
};

const state = getDefaultState();


const getters = {
    getTechClasses: (state) => {
        return state.techClasses;
    },
    getTechClassesLabels: (state) => {
        return Object.keys(state.techClasses);
    },
    getTechClassesColors: (state) => {
        let colors = [];
        for (const [key, value] of Object.entries(state.techClasses)) {
            colors.push(value.color);
        }
        return colors;
    },
    getBizClasses: (state) => {
        return state.bizClasses;
    },
    getBizClassesLabels: (state) => {
        return Object.keys(state.bizClasses);
    },
    getBizClassesColors: (state) => {
        let colors = [];
        for (const [key, value] of Object.entries(state.bizClasses)) {
            colors.push(value.color);
        }
        return colors;
    },
    getSources: (state) => {
        // if (!state.sources || Object.keys(state.sources).length === 0) {
        //     let urlsInfo = {
        //         method: "GET",
        //         url: UrlsService.getTrends()
        //     };
        //     APIService.call("normal", urlsInfo)
        //         .then(response => {
        //             state.sources = response.sources.trends;
        //         })
        // }
        return state.sources;
    },
    getDocuments: (state) => {
        return state.documents;
    },
};

const actions = {
    resetState ({ commit }) {
        commit("resetState");
    },
    setSources({commit}, sources) {
        commit("setSources", sources);
    },
};

const mutations = {
    resetState (state) {
        Object.assign(state, getDefaultState());
    },
    setSources(state, sources) {
        state.sources = sources;
        // salvare su mongo le modifiche da qui ??
        console.log('@@@@ RadarState.js -> SourcesState -> setSources: ' + state.sources);

    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
